import { render, staticRenderFns } from "./MobilePersonalMenu.vue?vue&type=template&id=650aa974&scoped=true"
import script from "./MobilePersonalMenu.vue?vue&type=script&lang=js"
export * from "./MobilePersonalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650aa974",
  null
  
)

export default component.exports